<template>
  <v-container>
    <v-row>
      <v-col :cols="12">
        <v-text-field
          @change="regeneratePDF()"
          label="Client Company [Optional]"
          v-model="client.institution"
        ></v-text-field>
      </v-col>

      <v-col :cols="12">
        <v-text-field
          @change="regeneratePDF()"
          label="Staff Name"
          v-model="client.name"
        ></v-text-field>
      </v-col>

      <v-col :cols="12">
        <v-text-field
          @change="regeneratePDF()"
          label="Position / Capacity [Optional]"
          v-model="client.position"
        ></v-text-field>
      </v-col>

      <v-col :cols="12">
        <v-text-field
          @change="regeneratePDF()"
          label="Phone Number [Optional]"
          v-model="client.phone"
        ></v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-col :cols="12">
        <v-text-field
          @change="regeneratePDF()"
          label="Email [Optional]"
          v-model="client.email"
        ></v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-col :cols="12">
        <v-text-field
          @change="regeneratePDF()"
          label="Physical Address [Optional]"
          v-model="client.address"
        ></v-text-field>
      </v-col>
      <v-col :cols="6">
        <v-text-field
          @change="regeneratePDF()"
          label="City [Optional]"
          v-model="client.city"
        ></v-text-field>
      </v-col>

      <v-col :cols="6">
        <v-text-field
          @change="regeneratePDF()"
          label="Postal Code [Optional]"
          v-model="client.postalCode"
        ></v-text-field>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      client: {
        name: "Staff Name",
        client_reference: "0210921923",
        phone: null,
        institution: "General Company",
        position: "Staff",
        email: "abc@gmail.com",
        address: "123 Street",
        city: "Durban",
        postal_code: "4001",
      },
    };
  },
  mounted() {
    this.regeneratePDF();
  },
  methods: {
    regeneratePDF() {
      this.$emit("client-updated", this.client);
    },
  },
};
</script>

<style></style>
